module.exports = __webpack_public_path__ + "static/media/content-min.be229bd1.png";